import React from 'react';
import { ErrorMessage, Field } from 'formik';
import Proptypes from 'prop-types';
import { formErrorMessage } from './FormErrorMessage';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import styled from 'styled-components';

export const PhoneInputContainer = styled(PhoneInput)`
  width: 100%;

  input {
    background-image: none;
    padding: 10px 18px;
    width: 100%;
    border-radius: 8px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    appearance: none;
    max-height: 46px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
    border: 1.5px solid
      ${({ theme, isLight }) => (isLight ? theme.dark60 : theme.dark70)};
    color: ${({ theme }) => theme.bodyMedium} !important;

    &:focus-within {
      color: ${({ theme }) => theme.inputColor};
      border: 1.5px solid
        ${({ theme }) => (theme.isLight ? theme.dark60 : theme.dark40)};
    }
    &:focus {
      box-shadow: none;
      color: ${({ theme }) => theme.inputColor};
      border: 1.5px solid
        ${({ theme, isLight }) => (isLight ? theme.dark60 : theme.dark70)};
      outline: 0;
    }
  }
`;

const FormikCountryInput = ({ name, placeholder, ...props }) => {
  return (
    <Field name={name}>
      {({ field: { value, name }, form: { setFieldValue, submitCount } }) => (
        <>
          <PhoneInputContainer
            name={name}
            id="phone"
            $fontSize="16px"
            international
            defaultCountry="US"
            placeholder={placeholder}
            value={value ? value : ''}
            limitMaxLength={true}
            countries={['AU', 'CA', 'GB', 'IT', 'US']}
            onChange={(e) => {
              setFieldValue(name, e);
            }}
            {...props}
          />

          {submitCount > 0 && (
            <ErrorMessage name={name} render={formErrorMessage} />
          )}
        </>
      )}
    </Field>
  );
};

FormikCountryInput.propTypes = {
  name: Proptypes.string.isRequired,
  placeholder: Proptypes.string,
  type: Proptypes.string,
  as: Proptypes.string,
  rows: Proptypes.string,
};

export default React.memo(FormikCountryInput);
